import * as types from '../../store/mutation-types';
import getInitialState from '../../api/getInitialState';
import Fuse from 'fuse.js';
import appConfig from '../../api/appConfig';
import DataPoll from "../../api/DataPoll";
import validateData from "../../util/validateData";

const dataPoll = new DataPoll();

// initial state
const state = getInitialState().appData;

// getters
const getters = {
  content: (state, getters, rootState) => {
    return state[rootState.currentLang]?.content || {};
  },
  categories: (state, getters, rootState) => {
    return state[rootState.currentLang]?.categories || [];
  },
  floors: (state, getters, rootState) => {
    return state[rootState.currentLang]?.floors || [];
  },
  reverseFloors: (state, getters, rootState) => {
    return state[rootState.currentLang]?.floors.slice().reverse() || [];
  },
  rooms: (state, getters, rootState) => {
    return state[rootState.currentLang]?.rooms;
  },
  shops: (state, getters, rootState) => {
    return state[rootState.currentLang]?.shops || [];
  },
  shopById: (state, getters, rootState) => (shopId) => {
    return state[rootState.currentLang]?.shops.find((shop) => shop.id === shopId);
  },
  currentShopData: (state, getters, rootState) => {
    return state[rootState.currentLang]?.shops.find((shop) => shop.id === getters.currentShop);
  },
  shopByRoomId: (state, getters, rootState) => (roomId) => {
    return state[rootState.currentLang]?.shops.find((shop) => shop.rooms.indexOf(roomId) !== -1);
  },
  shopsInCurrentCat: (state, getters, rootState) => {
    if (rootState.currentCat) {
      return state[rootState.currentLang]?.shops.filter(shop => {
        return shop.categories.indexOf(rootState.currentCat) !== -1;
      });
    } else {
      return state[rootState.currentLang]?.shops;
    }
  },
  shopSearchResults: (state, getters, rootState) => {
    if (rootState.searchQuery.length) {
      const fuse = new Fuse(state[rootState.currentLang].shops, appConfig.search);
      return fuse.search(rootState.searchQuery);
    } else {
      return state[rootState.currentLang]?.shops;
    }
  },
  specialOffers: (state, getters, rootState) => {
    return state[rootState.currentLang]?.specialOffers || [];
  },
  specialOfferById: (state, getters, rootState) => (shopId) => {
    return state[rootState.currentLang]?.specialOffers.find((offer) => offer.businessId === shopId);
  },
};

// actions
const actions = {
  dataPollStart({ commit, getters }) {
    dataPoll.start((data) => {
      if (validateData(data) && getters.isIdle) {
        console.log('**** update with real time data ******');
        commit(types.RECEIVE_DATA, data);
      }
    });
  },
  dataPollEnd() {
    dataPoll.end();
  },
  getCachedData({ commit }) {
    if (validateData(dataPoll.cachedData)) {
      console.log('**** update with cached data ******');
      commit(types.RECEIVE_DATA, dataPoll.cachedData);
    }
  },
};

// mutations
const mutations = {
  [types.RECEIVE_DATA](state, data) {
    state.en = data.en;
    state.et = data.et;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};


// fetch data
// if no result in 20sec fetch again
//
